module.exports = __webpack_public_path__ + "img/person-pinball.0813a4e9.svg";